import { Check } from "lucide-react";

import type { Criterion } from "@/content/alternatives/schema";

interface CriteriaGridProps {
  heading: string;
  description: string;
  criteria: Criterion[];
}

export function CriteriaGrid({ heading, description, criteria }: CriteriaGridProps) {
  return (
    <section className="bg-ash-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
            {heading}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ash-500">{description}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-x-12 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
          {criteria.map((criterion) => (
            <div key={criterion.title} className="flex gap-3">
              <div className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full bg-rebolt-500/15">
                <Check className="size-3.5 text-rebolt-500" strokeWidth={3} />
              </div>
              <div>
                <h3 className="text-base font-semibold text-ash-900">{criterion.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-ash-500">{criterion.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
